/* eslint-disable */
import { WebApi } from "@/services/WebApi"

const state = () => ({
    fetchedBookingPortalImage: false,
    fetchingBookingPortalImage: false,
    bookingPortalImage: null,
    attempted: false
})

const mutations = {
    setFetching(state, fetching) {
        state.fetchingBookingPortalImage = !!fetching;
        state.fetchedBookingPortalImage = false;
        state.attempted = true;
    },
    setBookingPortalImage(state, BookingPortalImage) {
        state.bookingPortalImage = BookingPortalImage;
        state.fetchingBookingPortalImage = false;
        state.fetchedBookingPortalImage = true;
    }
}

const actions = {
    fetchBookingPortalImage({ commit }, { siteId }) {
        return new Promise((resolve, reject) => {
            commit('setFetching', true);
            WebApi.get('Portal/' + siteId + '/Banner')
                .then(response => {
                    commit('setBookingPortalImage', response.data);
                    resolve(response);
                })
                .catch(error => {
                    commit('setFetching', false);
                    reject(error);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
